/* istanbul ignore file */
import { polyfill } from "es6-promise";
import $ from "jquery";
import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./app/App";
import { getTagManagerArgs } from "./helpers/GeneralHelper";
import store from "./redux/Store";
import * as serviceWorker from "./serviceWorker";

polyfill();
window.jQuery = $;

let checkoutAppC = window.hasOwnProperty("checkoutAppContext") ? window.checkoutAppContext : {};
let gtmEnabled = true;
if (checkoutAppC.hasOwnProperty("gtmEnabled")) {
	gtmEnabled = checkoutAppC.gtmEnabled;
}

// security issue, were not loading the GTM if the user is on the new password page
if (gtmEnabled && window.location.pathname !== "/newPassword") {
	TagManager.initialize(getTagManagerArgs());
}

// Export for shell integration
export function CheckoutApp() {
	return (
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	);
}

// Standalone app rendering (production builds)
if (document.getElementById("app")) {
	ReactDOM.render(<CheckoutApp />, document.getElementById("app"));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
